export class SetRights {
 constructor() { }

 setRight(auth): string {
  let add;
  let modify;
  let deactivate;
  let view;
  if (auth === '15') {
   //  No Rights
   add = false;
   modify = false;
   deactivate = false;
   view = false;
  } else if (auth === '14') {
   //  All Rights
   add = true;
   modify = true;
   deactivate = true;
   view = true;
  } else if (auth === '13') {
   //  Modify,Deactivate,View
   add = false;
   modify = true;
   deactivate = true;
   view = true;
  } else if (auth === '12') {
   //  Add,Modify,View
   add = true;
   modify = true;
   deactivate = false;
   view = true;
  } else if (auth === '11') {
   //  Add,Modify,Deactivate
   add = true;
   modify = true;
   deactivate = true;
   view = false;
  } else if (auth === '10') {
   //  Deactivate,View
   add = false;
   modify = false;
   deactivate = true;
   view = true;
  } else if (auth === '9') {
   //  Modify,View
   add = false;
   modify = true;
   deactivate = false;
   view = true;
  } else if (auth === '8') {
   //  Modify,Deactivate
   add = false;
   modify = true;
   deactivate = true;
   view = false;
  } else if (auth === '7') {
   //  Add,View
   add = true;
   modify = false;
   deactivate = false;
   view = true;
  } else if (auth === '6') {
   //  Add,Deactivate
   add = true;
   modify = false;
   deactivate = true;
   view = false;
  } else if (auth === '5') {
   //  Add,Modify
   add = true;
   modify = true;
   deactivate = false;
   view = false;
  } else if (auth === '4') {
   //  View
   add = false;
   modify = false;
   deactivate = false;
   view = true;
  } else if (auth === '3') {
   //  Deactivate
   add = false;
   modify = false;
   deactivate = true;
   view = false;
  } else if (auth === '2') {
   //  Modify
   add = false;
   modify = true;
   deactivate = false;
   view = false;
  } else if (auth === '1') {
   //  Add
   add = true;
   modify = false;
   deactivate = false;
   view = false;
  }
  return add + ',' + modify + ',' + deactivate + ',' + view; // Returning Add,Modify,Deactivate,View as string
 }
}
